import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-competition-title-link-cell',
  templateUrl: './competition-title-link-cell.component.html',
  styleUrls: ['./competition-title-link-cell.component.css']
})
export class CompetitionTitleLinkCellComponent implements AgRendererComponent {
  name: string;
  id: string;

  constructor() {}

  refresh(params: ICellRendererParams): boolean {
    this.name = params.data.name;
    this.id = params.data.id;
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.name = params.data.name;
    this.id = params.data.id;
  }
}
